"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContinuanceAbilityHandler = exports.ContinuanceActorAbilityFactory = exports.ContinuanceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_3 = require("../../core/event-handlers/core");
class ContinuanceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Continuance;
        this.__typeName = "Continuance";
    }
}
exports.ContinuanceAbilityArgs = ContinuanceAbilityArgs;
let ContinuanceActorAbilityFactory = class ContinuanceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Continuance", "Self", 0);
    }
};
ContinuanceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Continuance")
], ContinuanceActorAbilityFactory);
exports.ContinuanceActorAbilityFactory = ContinuanceActorAbilityFactory;
let ContinuanceAbilityHandler = class ContinuanceAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            supernatural: true,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.PassiveBuffEffectArgs("Continuance", "Time passes for everyone...", new core_1.LinkedEventHandlerEffectArgs("Continuance", "Time passes for everyone...", false, container.registerEventHandler(actorId, EventType_1.EventType.Tick, Schedule_1.Schedule.Unlimited, new core_3.ApplyEffectEventHandlerArgs(actorId, Target_1.Target.All, Duration_1.Duration.Permanent, new core_1.WitheringEffectArgs("Focus", 10))))),
            onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "feet"), "TimeCircleLightPillar"))
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ABILITY");
    }
};
ContinuanceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Continuance)
], ContinuanceAbilityHandler);
exports.ContinuanceAbilityHandler = ContinuanceAbilityHandler;
